import ROHistoryCardPanel from 'src/components/ROHistoryCard/ROHistoryCardPanel/ROHistoryCardPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    roHistory: state.ROHistory.allRoHistory.roHistory,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    theme: state.Framework.theme,
});

export default connect(mapStateToProps)(ROHistoryCardPanel);